import React from 'react';
import moment from 'moment';

import Payment from '../../types/payment';
import { currencyNumberFormat } from '../../../../utilities/number-format';
import {
  CardListItem,
  CardContent,
  Label,
  Value
} from '../InvoiceCardList/InvoiceCardListItem.styled';

interface Props {
  payment: Payment;
}

const UnappliedPaymentCardListItem = ({ payment }: Props) => {
  const { date, reason, amountCents, azAppliedAmountCents } = payment;

  return (
    <CardListItem>
      <CardContent>
        <Label>Date of Service</Label>
        <Value>{moment(date).format('MM/DD/YYYY')}</Value>

        <Label>Reason</Label>
        <Value>{reason}</Value>

        <Label>Amount</Label>
        <Value>{currencyNumberFormat(amountCents / 100.0)}</Value>

        <Label>Applied Amount</Label>
        <Value>{currencyNumberFormat(azAppliedAmountCents / 100.0)}</Value>
      </CardContent>
    </CardListItem>
  );
};

export default UnappliedPaymentCardListItem;
